<template>
  <div class="" :value="value" v-show="showPop">
    <van-dialog
      v-model="showPop"
      show-cancel-button
      confirmButtonText="保存"
      @confirm="add"
    >
      <van-cell-group>
        <van-cell title="产品分类">
          <div class="flex item1" @click="showType=!showType">
            <p class="item1 date-time c-black" v-if="obj.U_MaterialClass">{{obj.U_MaterialClass}}</p>
            <p class="item1 date-time" v-else>请选择</p>
            <div slot="right-icon"  class="triangle_border_down" />
          </div>
        </van-cell>
        <van-cell title="名称">
          <van-field   placeholder="请输入名称" class="item2" v-model="obj.Name" @input="limitLength(100,'obj','Name')"/>
        </van-cell>
        <van-cell title="数量">
          <van-field   type="number" placeholder="请输入数量" class="item2" v-model="obj.U_Qty" @input="limitLength(15,'obj','U_Qty')"/>
        </van-cell>
        <van-cell title="归还日期" is-link arrow-direction="down" :value="obj.U_ReturnDate|getDate" @click="showDateTime=!showDateTime"/>
      </van-cell-group>
    </van-dialog>
    <van-popup v-model="showDateTime" position="bottom" @click-overlay="showDateTime=!showDateTime">
      <van-datetime-picker
        :min-date="info.U_ReturnDate"
        v-if="showPop"
        type="date"
        @confirm="getTime"
        @cancel="showDateTime=!showDateTime"
      />
    </van-popup>
    <van-popup v-model="showType" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        :columns="pickerList"
        value-key="name"
        @confirm="typeChange"
        @cancel="showType = !showType"
      />
    </van-popup>
  </div>
</template>
<script>
  import moment from 'moment'
  export default{
    data(){
      return {
        obj:{
          U_MaterialClass:'',  //物料类别
          Name : '',
          U_Qty : "",
          U_ReturnDate:new Date()   //归还日期
        },
        showPop:false,
        showDateTime:false,

        showType:false,
        pickerList:[
          {
            name:'请选择',
            value:''
          }
        ],
      }
    },
    props:{
      value:{
        type:Boolean,
        default:false
      },
      info:{}
    },
    filters: {
      getDate: function (value) {
        if (!value) return ''
        return moment(value).format('YYYY-MM-DD')
      },
    },
    watch:{
      value(val){
        this.showPop = val
      },
      showPop(val){
        this.info.U_ReturnDate=new Date(this.info.U_ReturnDate)
        if(!val){
          this.obj={
            U_MaterialClass:'',  //物料类别
            Name : '',
            U_Qty : "",
            U_ReturnDate:this.info.U_ReturnDate||new Date()   //归还日期
          }
        }else if(this.info){
          this.obj={
            U_Sort:this.info.U_Sort,
            U_MaterialClass:this.info.U_MaterialClass,  //物料类别
            Name : this.info.Name,
            U_Qty :this.info.U_Qty,
            U_ReturnDate:this.info.U_ReturnDate   //归还日期
          }
        }
        this.obj.U_ReturnDate =this.info.U_ReturnDate ||new Date()
        this.$emit('input',val)
      },
//      info(){
//        if(this.info.U_Sort!==''){
//          this.obj={
//            U_Sort:this.info.U_Sort,
//            U_MaterialClass:this.info.U_MaterialClass,  //物料类别
//            Name : this.info.Name,
//            U_Qty :this.info.U_Qty,
//            U_ReturnDate:this.info.U_ReturnDate   //归还日期
//          }
//        }
//      }
    },
    methods:{
      getTime(e){
        this.showDateTime=!this.showDateTime
        console.log(e,moment(e).format('YYYY-MM-DD'))
        this.obj.U_ReturnDate=moment(e).format('YYYY-MM-DD')
      },
      getCols(){
        this.$api.getQueryByTcode({
          tcode:'Products1stType'
        }).then(response=>{
          this.pickerList =this.pickerList.concat(response.data)
        })
      },
      typeChange(e){
        this.showType=!this.showType
        if(!e.value){
            return
        }
        this.obj.U_MaterialClass = e.name
      },
      add(){
        if(!this.obj.Name){
          this.$title('请输入名称')
          return
        }else if(!this.obj.U_Qty||!/(^[1-9]\d*$)/.test(this.obj.U_Qty)){
          this.$title('请输入数量,且数量只能为正整数')
          return
        }else if(!this.obj.U_MaterialClass){
          this.$title('请输入物料类别')
          return
        }else if(!this.obj.U_ReturnDate){
          this.$title('请选择归还日期')
          return
        }
//        this.obj.U_ReturnDate=moment(this.obj.U_ReturnDate).format('YYYY-MM-DD')
        this.$emit('newWuliao',this.obj)
      },
      limitLength(len,key1,key2){
        let value = ''
        if(key2){
          value =this.$data[key1][key2]
        }else{
          value =this.$data[key1]
        }
        if(value.length>len){
          if(key2){
            this.$data[key1][key2]=value.slice(0,len)
          }else{
            this.$data[key1]=value.slice(0,len)
          }
        }
      }
    },
    created(){
      this.getCols()
    }
  }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../../style/pageStyle/pageView-activeDetail.less";
  .van-cell__title{
    width:60px;
  }
  .van-cell__value{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/active/component/wuliaoPop.vue